module.exports = __webpack_public_path__ + "img/andre-silva.98b01fd9.jpg";